import React from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { CheckSerialNumberLicense } from './CheckSerialNumberLicense';
import { CheckModuleKeyLicense } from './CheckModuleKeyLicense';

export const CheckLicense: React.FC = props => {
    return <Container>
        <h4>Check license</h4>
        <Row>
            <Col>
                <Tabs>
                    <Tab eventKey="serialNumber" title="Serial number">
                        <CheckSerialNumberLicense />
                    </Tab>
                    <Tab eventKey="moduleKey" title="Module key">
                        <CheckModuleKeyLicense />
                    </Tab>
                </Tabs>
            </Col>
        </Row>
    </Container>
}